import React, { useState } from "react";
import List, { ContactHeaderActions } from "./components/list";
import AddContacts from "./components/addContacts";
import { CompanyPage, Tabs } from "../../components/common";
import CampaignList, {
  CampaignHeaderActions,
} from "./components/campaign/campaignList";

const TABS = [
  { id: 1, label: "Add Contacts", value: "addContacts" },
  { id: 2, label: "Manage Campaign", value: "manageCampaign" },
  { id: 3, label: "Manage Contacts", value: "manageContacts" },
];

const MarketingSolution = () => {
  const [checkTab, setCheckTab] = useState("addContacts");
  const active = TABS.find((tab) => tab.value === checkTab) || TABS[0];
  const isListTab =
    checkTab === "manageContacts" || checkTab === "manageCampaign";

  return (
    <CompanyPage
      className="page-marketing"
      padded={!isListTab}
      header={
        <>
          <CompanyPage.HeaderLeft>
            <Tabs
              tabs={TABS}
              active={active}
              setActive={(tab) => setCheckTab(tab.value || "addContacts")}
            />
          </CompanyPage.HeaderLeft>
          {checkTab === "manageCampaign" && (
            <CompanyPage.HeaderRight>
              <CampaignHeaderActions />
            </CompanyPage.HeaderRight>
          )}
          {checkTab === "manageContacts" && (
            <CompanyPage.HeaderRight>
              <ContactHeaderActions />
            </CompanyPage.HeaderRight>
          )}
        </>
      }
    >
      {checkTab === "addContacts" && <AddContacts />}
      {checkTab === "manageContacts" && <List embedded />}
      {checkTab === "manageCampaign" && <CampaignList />}
    </CompanyPage>
  );
};
export default MarketingSolution;
